import { createOptionsFrom } from "@/lib/common/Option";

export const EvCategoryVariantSortLabels = {
	Alphabetical: "Alphabetical",
	HighestMarketPrice: "Highest Market Price",
	ShortPrintedDescending: "Short Printed"
} as const;

export type EvCategoryVariantSort = keyof typeof EvCategoryVariantSortLabels;

export const EvCategoryVariantSortOptions = createOptionsFrom(EvCategoryVariantSortLabels);
